import React from 'react'

export default function Button( { color, clickFunction, type='button', children } ) {

    function getStyles() {
        let styles;
        switch (color) {
            case 'green':
                styles = "text-2xl w-4/6 my-2 rounded-lg border-2 bg-green-600 border-gray-800 pt-2 pb-2 font-bold text-gray-50 hover:text-green-600 hover:bg-gray-50"
                break;
            case 'yellow':
                styles = "text-2xl w-4/6 my-2 rounded-lg border-2 bg-yellow-500 border-gray-800 pt-2 pb-2 font-bold text-gray-50 hover:text-yellow-500 hover:bg-gray-50"
                break
            case 'gray':
                styles = "text-2xl w-4/6 my-2 rounded-lg border-2 bg-slate-400 border-gray-800 pt-2 pb-2 font-bold text-gray-50 hover:text-slate-400 hover:bg-gray-50"
                break
            default:
                break;
        }
        return styles
    }

    return (
        <button
            onClick={clickFunction}
            type={type}
            className={getStyles()}
        >
            {children}
        </button>
    )
}
